import dayjs from 'dayjs';
import {useMemo} from 'react';

import {Text} from '../../../../component/text/text';
import {Locale} from '../../../../provider/locale/locale';
import {useLpsAverageRating} from '../../../../service/dashboard/dashboard-lps/dashboard-lps-hook';

import {LpsStatus} from './lps-status/lps-status';

export function LpsRatingStatus(): JSX.Element {
    const {startDate, endDate} = useMemo(
        () => ({
            startDate: dayjs().subtract(2, 'day').format('YYYY-MM-DD'),
            endDate: dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
        }),
        []
    );

    const {data} = useLpsAverageRating({startDate, endDate});

    return (
        <Text bolder>
            <Locale
                stringKey="DASHBOARD_PAGE__LPS_RATING"
                valueMap={{
                    rating: <LpsStatus value={data?.[1]?.avgLps || 0} />,
                }}
            />
        </Text>
    );
}
